module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p6-d4ab93f9d201891a331d35aef6c4137c.png";